import React from 'react'
import CognitoUserDetail from './abstract/CognitoUserDetail'
import Config from '../../../Config'
import Loading from '../../../common/component/Loading'
import FormatCheckTextBox from '../../../common/component/FormatCheckTextBox'

class CompanyUserDetail extends CognitoUserDetail {
  constructor(props) {
    super(props)
    this.state = { userDetail: '', temporaryPassword: '', email: '', isInheritingModalOpen: false, inheritingMessage: '' }
    this.apiUrl = Config.adminApiUrl.userManagement
    this.userRoleName = '企業ユーザ'
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
    this.parentUserRoleUrl = 'company'

    // toggleInheritingModal の this をバインド
    this.toggleInheritingModal = this.toggleInheritingModal.bind(this)
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search)
    const temporaryPassword = queryParams.get('temporaryPassword')

    if (temporaryPassword) {
      this.setState({ temporaryPassword })
    }
  }

  toggleInheritingModal() {
    this.setState((prevState) => ({
      isInheritingModalOpen: !prevState.isInheritingModalOpen
    }))
  }
  onInheritingButtonClicked (action, e) {
    e.preventDefault()
    switch (action) {
      case 'save' :
        this.inheritingEstimation(this.state.email)
        break
      case 'cancel' :
        this.setState({ isInheritingModalOpen: false, email: '', saveMessage: '', inheritingMessage: '' })
        break
      default:
        break
    }
  }
  changed (name, e) {
    this.setState({[name]: e.target.value})
  }

  renderInheriting() {
    const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
    return (
      <ul className='nav nav-list' id='person-list'>
        <li className='nav-header'>過去データ引き継ぎ</li>
        <li className='text-center'>
          {this.state.saveMessage && <div className="alert alert-success">{this.state.saveMessage}</div>}
          過去の見積データの引き継ぎを行います。<br />
          以前、使用していたメールアドレスを入力し、<br />
          「データ引き継ぎ」を押下してください。<br />
          <br />
          メールアドレス：<FormatCheckTextBox className='span5' value={this.state.email} autoComplete='false' onChange={e => this.changed('email', e)} pattern={emailPattern} message='正しいメールアドレスの形式で入力してください' />
          <hr />
          {this.state.inheritingMessage}<br />
          <button className='btn btn-small btn-primary' onClick={(e) => this.onInheritingButtonClicked('save', e)}>データ引き継ぎ</button>　
          <button className='btn btn-small btn-default' onClick={(e) => this.onInheritingButtonClicked('cancel', e)}>終了</button>
        </li>
        <li className='nav-header'></li>
      </ul>
    )
  }

  render() {
    if (!this.state.isLoaded) {
      return <Loading />
    }

    const userDetail = this.renderUserDetail(this.userRoleName + '情報', '氏名', this.state.userDetail, this.state.temporaryPassword)
    const disableButton = (
      <li key='disable' className='kw-btn-area'>
        <button id='suspend-button' rel='tooltip' title='一時無効' data-placement='bottom' className='kw-btn-info' onClick={(e) => this.onPageMenuClicked('disable', e)} >
          <i className='icon-eye-close icon-large' />
          <span>一時<br />無効</span>
        </button>
      </li>
    )
    const enableButton = (
      <li key='enable' className='kw-btn-area'>
        <button id='resurrection-button' rel='tooltip' title='復活' data-placement='bottom' className='kw-btn-info' onClick={(e) => this.onPageMenuClicked('enable', e)} >
          <i className='icon-heart-empty icon-large' />
          <span>復活</span>
        </button>
      </li>
    )
    const disableOrEnable = this.state.userDetail.enabled ? disableButton : enableButton
    const inheritingBox = this.renderInheriting()

    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>{this.userRoleName}情報 - 詳細<br /><small>こちらで{this.userRoleName}の情報を参照できます。</small></h3>
                </header>
              </div>
              <div className='span9'>
                <ul className='nav nav-pills'>
                  <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back', e)} ><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
                  <li className='kw-btn-area'><button id='edit-button' rel='tooltip' title='編集' data-placement='bottom' className='kw-btn-success' onClick={(e) => this.onPageMenuClicked('edit', e)} ><i className='icon-edit icon-large' /><span>編集</span></button></li>
                  <li key='ban' className='kw-btn-area'><button id='delete-button' rel='tooltip' title='削除' data-placement='bottom' className='kw-btn-danger' onClick={(e) => this.onPageMenuClicked('ban', e)} ><i className='icon-remove icon-large' /><span>削除</span></button></li>
                  {disableOrEnable}
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className='page container form-horizontal'>
          <div className='row'>
            <div className='span11'>
              {userDetail}
            </div>
            <div className='span5'>
              <div className="btn-group-box text-center">
                <button className="text-center inheriting kw-btn-primary" onClick={this.toggleInheritingModal}>
                  <span className="button-text"> 過去データ引き継ぎ </span>
                </button>
              </div>
            </div>
          </div>
        </section>

        {this.state.isInheritingModalOpen && (
          <div className="modal">
            <div className="modal-content">
              <span className="close" onClick={this.toggleInheritingModal}>&times;</span>
              {inheritingBox}
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default CompanyUserDetail


// WEBPACK FOOTER //
// ./src/admin/pages/secure/CompanyUserDetail.js